import { faCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC } from 'react';
import Settings from '../Settings/Settings';
import SvgIcon from '../SvgIcon/SvgIcon';
import briefcaseSvg from '../../images/briefcase.svg';
import styles from './Header.module.scss';
import TestIds from '../../tests/TestIds';

interface Props {
	name?: string;
	showBadge?: boolean;
}

const Header: FC<Props> = ({ name, showBadge = true }) => {
	return (
		<div className={styles.container} data-cy={TestIds.Header}>
			<div className={styles.title}>
				<div className={styles.iconWrapper}>
					<SvgIcon className={styles.icon} src={briefcaseSvg} />
				</div>
				{name && (
					<h3 className={styles.name} data-cy={TestIds.HeaderName}>
						{name}
					</h3>
				)}
				{false /* disabled for 1.86 because of reasons */ && name && showBadge && (
					<FontAwesomeIcon
						className={styles.checkIcon}
						icon={faCircleCheck}
						data-cy={TestIds.HeaderBadge}
					/>
				)}
			</div>
			<Settings />
		</div>
	);
};

export default Header;
